import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  const displayTestimonials = testimonials.slice(0, 4);

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="text-xs font-semibold tracking-widest uppercase text-primary-600">
              用户口碑
            </span>
            <h2 className="mt-3 text-2xl md:text-4xl font-bold text-foreground-950">
              听听 <strong>用户</strong> 怎么说
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              来自真实用户与合作伙伴的评价，98% 好评率是最好的证明
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {displayTestimonials.map((t) => (
              <div
                key={t.id}
                className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-7"
              >
                <div className="flex items-center gap-1 text-accent-500">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">
                  "{t.content}"
                </blockquote>
                <div className="mt-5 flex items-center gap-3">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.title}</p>
                  </div>
                </div>
                <div className="mt-3 pt-3 border-t border-background-200/70">
                  <span className="text-xs text-accent-600 font-medium bg-accent-100 px-2.5 py-1 rounded-full whitespace-nowrap">
                    {t.product}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}